import { useRef } from "react";

import { signIn, signOut, useSession } from "@hono/auth-js/react";
import { Outlet } from "react-router";

import RunningDogAss from "~/ass/running_dog.json";
import AnimatedSticker from "~/components/animated-stickers";
import { AppSidebar } from "~/components/app-sidebar";
import { Button } from "~/components/ui/button";
import { SidebarProvider, SidebarTrigger } from "~/components/ui/sidebar";

const Layout = () => {
  const navbarRef = useRef<HTMLElement>(null);
  const session = useSession();

  if (session.status === "loading") {
    return (
      <AnimatedSticker
        title="Authentication"
        desc="Loading, please wait..."
        data={{
          raw: RunningDogAss,
        }}
      />
    );
  }

  return (
    <SidebarProvider defaultOpen={session.status === "authenticated"}>
      <AppSidebar />
      <main className="flex flex-col w-full justify-between items-center min-h-[100svh] relative overflow-x-hidden">
        <nav
          ref={navbarRef}
          className="w-full flex outline-1 bg-secondary p-2 sticky top-0 justify-between items-center"
        >
          <SidebarTrigger />
          <AuthButton />
        </nav>
        <Outlet />
      </main>
    </SidebarProvider>
  );
};

export default Layout;

const AuthButton = () => {
  const auth = useSession();

  return (
    <div className="flex flex-col items-center justify-center gap-4 ms-auto">
      {auth.status === "authenticated" && (
        <div className="flex w-full justify-between items-center gap-3">
          <Button variant="outline" onClick={() => signOut()}>
            Sign out
          </Button>
        </div>
      )}
      {auth.status === "unauthenticated" && (
        <Button onClick={() => signIn()} variant="default">
          Sign in
        </Button>
      )}
      {auth.status !== "authenticated" && auth.status !== "unauthenticated" && (
        <div>Loading...</div>
      )}
    </div>
  );
};
